import React from 'react';
import likeThumb from '../../../img/popup-like.png';
import ohnoImg from '../../../img/ohno.png';
import './likePopup.css';

export default function LikePopup({ mode, onClose }) {
  if (!mode) return null;

  const isThanks = mode === 'thanks';

  return (
    <div className="game-like-backdrop" onClick={onClose} role="presentation">
      <div className="game-like-popup" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <img
          className={isThanks ? 'game-like-popup-thumb' : 'game-like-ohno'}
          src={isThanks ? likeThumb : ohnoImg}
          alt={isThanks ? 'Thumbs up' : 'Already liked'}
        />
        {isThanks ? <div className="game-like-popup-text">Thank you for liking!</div> : null}
        {!isThanks ? <div className="game-like-popup-text game-like-popup-text--warn">You have already liked!</div> : null}
        <button type="button" className="game-like-popup-ok" onClick={onClose}>
          OK
        </button>
      </div>
    </div>
  );
}
